<script>
  export let pm = {};
  let className = '';
  export { className as class };
</script>


<div class={className}>
  <div class="ads-bar atk mb-1" style="--ratio: {pm._atk / 500}">Atk: {pm._atk}</div>
  <div class="ads-bar def mb-1" style="--ratio: {pm._def / 500}">Def: {pm._def}</div>
  <div class="ads-bar sta mb-1" style="--ratio: {pm._sta / 500}">Sta: {pm._sta}</div>
</div>


<style>
  .ads-bar {
    position: relative;
    font-size: small;
    padding-right: 1rem;
    opacity: .6;
    /* color: #666; */
  }
  .ads-bar::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    height: 2px;
    background-color: #7773;
    background-image: linear-gradient(90deg, transparent, currentcolor);
    background-size: calc(var(--ratio, 0) * 100%) 100%;
    background-repeat: no-repeat;
  }
</style>
